import React, {ReactNode, useCallback} from "react";
import {useAuthStore} from "../../../store/auth.store";
import {Stack, FormControlLabel, Checkbox} from "@mui/material";
import {getProposalOptions} from "./ProposalStatusDropdown";


interface Props {
    includeHints?: boolean
    value: string[],
    label?: ReactNode,
    onChange: (v: string[]) => void
}


export function ProposalStatusPanel({label, includeHints, value, onChange}: Props) {
    const {can} = useAuthStore();

    const options = getProposalOptions(can('manage_proposals'), includeHints)

    const values = value.reduce((map, v) => {
        map[v] = true;
        return map;
    }, {} as Record<string, boolean>)

    const localOnChange = useCallback((e:React.ChangeEvent<HTMLInputElement>, checked:boolean) => {
        const newValue = [...value];
        for(let i = 0; i < value.length; i++) {
            if(value[i] === e.target.name) {
                newValue.splice(i, 1);
                onChange(newValue);
                return;
            }
        }
        newValue.push(e.target.name);
        onChange(newValue);
    }, [value, onChange]);

    return <Stack>
        {label}
        {options.map(o => {
            return <FormControlLabel
                key={o.value}
                control={<Checkbox style={{padding: '4px'}}
                                   name={o.value as string}
                                   checked={!!values[o.value]}
                                   onChange={localOnChange} />}
                label={o.label}
                sx={{
                    // This affects the wrapper around the control + label
                    alignItems: 'center',

                    // Force the LABEL wrapper to center its contents
                    '& .MuiFormControlLabel-label .MuiStack-root': {
                        display: 'flex',
                        alignItems: 'center',
                    },
                }}
            />
        })}
    </Stack>
}